import { currentApi } from '../../model/currentApi';

export const getContentApiBase = (): string =>
  currentApi.value.includes('dev')
    ? 'https://grid-api-dev.terratraf.com/content/'
    : 'https://grid-api.terratraf.com/content/';

export type ContentDownloadType = 'board';

export const getContentDownloadUrl = (
  uuid: string,
  type?: ContentDownloadType,
): string => {
  const params = new URLSearchParams({ uuid });
  if (type) {
    params.set('type', type);
  }
  return `${getContentApiBase()}download/?${params.toString()}`;
};
